import { useState } from "react";
import { toast } from "sonner";

interface UseSaleConfirmationProps {
  selectedItem: any;
  isGroupSale: boolean;
  selectedProducts: any[];
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  sellerSignature: string;
}

export const useSaleConfirmation = ({
  selectedItem,
  isGroupSale,
  selectedProducts,
  onConfirm,
  onOpenChange,
  sellerSignature,
}: UseSaleConfirmationProps) => {
  const [isConfirming, setIsConfirming] = useState(false);

  const handleConfirm = async () => {
    try {
      if (!sellerSignature) {
        toast.error("Veuillez ajouter votre signature pour confirmer la transaction");
        return;
      }

      if (!isGroupSale && (!selectedItem || !selectedItem.data)) {
        toast.error("Veuillez sélectionner un produit");
        return;
      }

      if (isGroupSale && (!selectedProducts || selectedProducts.length === 0)) {
        toast.error("Veuillez sélectionner au moins un produit pour la vente groupée");
        return;
      }

      setIsConfirming(true);
      await onConfirm();
      toast.success("Vente confirmée avec succès");
      onOpenChange(false);
    } catch (error) {
      console.error("Erreur lors de la confirmation de la vente:", error);
      toast.error("Erreur lors de la confirmation de la vente");
    } finally {
      setIsConfirming(false);
    }
  };

  return {
    isConfirming,
    handleConfirm,
  };
};